import { createFileRoute } from '@tanstack/react-router';
import { FavoritesPage } from '@/components/custom/favorites-page';
import { websiteConfig } from '@/config/website';
import { m } from '@/locale/paraglide/messages';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/favorites')({
  head: () => {
    const siteName = websiteConfig.metadata?.name ?? '';
    const title = siteName
      ? `${m.favorites_title()} | ${siteName}`
      : m.favorites_title();
    return seo('/favorites', {
      title,
      description: m.favorites_meta_description(),
      indexable: false,
    });
  },
  component: FavoritesPage,
});
